import React from "react";
import WorkerGatePass from "./workerGate";
class WorkerGatePassParent extends React.Component {
  render() {
    return <WorkerGatePass type={"WGR"} title={"Work Permit"} />;
  }
}

export default WorkerGatePassParent;
